// neo_cogym — 비전 브리지 (W4)
// 코딩스쿨 비전 확장(HandRecognition/PoseDetection/FaceRecognition/TM_image)은
// 렌더러(VM)에서 추론 결과를 읽어 블록 센싱에 쓴다. 웹에선 P3 OzEye(온디바이스 TF.js)를
// 구동하고 최신 결과를 전역 스토어에 두어 확장이 동기적으로 읽게 한다(영상 비전송 유지).
//
// 또한 코딩스쿨의 luka-capture-window(화면 캡처→Gemini) 를 캔버스 캡처로 치환해 AI프록시에 전달.

import { OzEye, type HandResult } from "./ozEye";

export interface VisionState {
  hands: HandResult[];
  updatedAt: number;
}

// 확장이 읽는 전역(동기 접근). window.__neoVision 으로도 노출.
const state: VisionState = { hands: [], updatedAt: 0 };

export function getVisionState(): Readonly<VisionState> {
  return state;
}

let ozEye: OzEye | null = null;

/** 비전 시작: 카메라 + handpose 온디바이스 추론 → state 갱신 */
export async function startVision(video: HTMLVideoElement, modelBasePath?: string): Promise<void> {
  if (ozEye) return;
  ozEye = new OzEye({
    video,
    modelBasePath,
    fps: 15,
    onHands: (hands) => {
      state.hands = hands;
      state.updatedAt = Date.now();
    },
  });
  await ozEye.start();
  (window as unknown as { __neoVision?: VisionState }).__neoVision = state;
}

export function stopVision(): void {
  ozEye?.stop();
  ozEye = null;
}

/**
 * 화면 캡처 → JPEG data URL (코딩스쿨 luka-capture-window 치환).
 * 긴 변 1280px 이하로 축소(원본 IPC 핸들러와 동일 정책).
 */
export function captureToDataUrl(source: HTMLCanvasElement | HTMLVideoElement, maxEdge = 1280): string {
  const sw = "videoWidth" in source ? source.videoWidth : source.width;
  const sh = "videoHeight" in source ? source.videoHeight : source.height;
  const scale = Math.min(1, maxEdge / Math.max(sw || 1, sh || 1));
  const w = Math.round((sw || maxEdge) * scale);
  const h = Math.round((sh || maxEdge) * scale);
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  canvas.getContext("2d")!.drawImage(source, 0, 0, w, h);
  return canvas.toDataURL("image/jpeg", 0.8);
}
